import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.wallet.method,
    (method) => {
        return {
            method
        }
    }
)